import React, { Component } from 'react';
import { Row, Form, Col } from 'react-bootstrap';
import debounce from 'lodash-es/debounce';
import isEqual from 'lodash-es/isEqual';
import { Api } from '../utils/api';
import Grid from '@material-ui/core/Grid';
import TablePagination from '@material-ui/core/TablePagination';
import EntitiesListTable from './components/entities_list_table.component';


const entities = [{
    /*"ep_key":4732,
    "id":4732,
    "easypay_reference_id":47382,
    "entity_name": "Lar São José de Aldoar, Lda",
    "plan_name": "Base",
    "error":0,
    "payment_at":"2019-03-27 00:00:00",
    "next_payment_at":"2019-04-27 00:00:00",
    "auto":1,
    "status":1*/
}];

class EntityInvoicesList extends Component {

  state = {
    entities,
    page: 1,
    count: 0,
    query: ''
  };

  constructor() {
    super();
    this.api = new Api();
    this.search = debounce(this.searchInitial.bind(this), 250, { leading: true });
    this.onChange = this.onChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }

  oldValues = null;

  componentDidMount() {
    this.handleChangePage();
  }

  /** 
   * Search bar 
   */

  searchInitial(query) {
    const { page } = this.state;
    this.api.get('/entities', { search: query, page })
      .then(({ data : { entities, count } }) => {
        this.setState({ entities, count, query, page });
      });
  }

  handleChangePage(event ,page) {
    if (page === 0) return;
    this.setState({ page });
    this.searchInitial(this.state.query);
  }

  onChange(event) {
    this.search(event.target.value);
  }

  /** 
   * Other search components
   */

  handleChange(values) {
    this.findEntities({
      ...values
    });
  }

  findEntities(searchValues, force=false) {
    if (isEqual(searchValues, this.oldValues || {}) && !force) {
      return;
    }
    this.oldValues = searchValues;
    const { page } = this.state;

    this.api.get('/entities', {
      ...searchValues,
      page
    })
    .then(({ data : { entities, count } }) => {
      this.setState({ entities, count });
    });
  }

  /**
   * 
   */

  render() {
    const { entities } = this.state;
    return (
      <>
        <Row>
          <Col xs={1}/>
          <Col md={8}>
            <Form style={{ width: '100%'}}>
              <Form.Control type="text" placeholder="Search Here" onChange={this.onChange}/>
            </Form>
          </Col>
          <Col xs={1}/>
        </Row>
        
        <EntitiesListTable
          entities={entities}
        />

        <Grid container >
          <Grid item md={12} >
            <TablePagination className="pagination"
              rowsPerPageOptions={[]}
              count={this.state.count}
              rowsPerPage={10}
              page={this.state.page}
              onChangePage={this.handleChangePage}
            />
          </Grid>
          
        </Grid>
      </>
    );
  }
}

export default EntityInvoicesList;